<div class="translations-banner-wrapper">
  <button
    *ngIf="userLang && LINK_TARGET"
    class="banner-wrapper"
    (click)="openTargetInNewPage()"
    (keydown.enter)="openTargetInNewPage()"
    (keydown.space)="openTargetInNewPage(); $event.preventDefault()"
    [attr.aria-labelledby]="'translations-banner-slogan'"
    [class.fix-ru]="userLang === 'ru'"
    [class.fix-uk]="userLang === 'uk'"
    [class.fix-en]="userLang === 'en'"
    [class.fix-pl]="userLang === 'pl'">
    <span id="translations-banner-slogan" class="sr-only" [innerHTML]="'TRANSLATIONS_BANNER.SLOGAN' | translate">
    </span>

    <div class="column align-end" aria-hidden="true">
      <video muted autoplay loop playsinline tabindex="-1">
        <source src="https://kartapobytu.app/kp/anim-simple-translations-fixed-bg.mp4" type="video/mp4" />
      </video>
    </div>

    <div class="column align-start" inert>
      <div class="slogan-container" [innerHTML]="'TRANSLATIONS_BANNER.SLOGAN' | translate"></div>

      <div
        *ngIf="deviceTypeDetected === 'DESKTOP' || deviceTypeDetected === 'TABLET'"
        class="disclaimer-container"
        [innerHTML]="'TRANSLATIONS_BANNER.DISCLAIMER' | translate"></div>
    </div>
  </button>

  <div
    *ngIf="deviceTypeDetected === 'PHONE'"
    class="disclaimer-container"
    [innerHTML]="'TRANSLATIONS_BANNER.DISCLAIMER' | translate"></div>
</div>
